export default __webpack_public_path__ + "static/media/ai_icon_3.7084fe3b.png";